export default __webpack_public_path__ + "static/media/480_portfolio02-jp-mobile.e4d2faf9.png";